import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Axios from "axios";
import OutdatedBrowser from "outdated-browser-rework";
import MapBoxGL from "mapbox-gl";
import LightGallery from "lightgallery.js";
import NoUISlider from "nouislider";
import LazyLoad from "vanilla-lazyload";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;
(<any>window).OutdatedBrowser = OutdatedBrowser;
(<any>window).MapBoxGL = MapBoxGL;
(<any>window).LightGallery = LightGallery;
(<any>window).NoUISlider = NoUISlider;
(<any>window).LazyLoad = LazyLoad;